import cls from 'classnames';
import React from 'react';

const ViewLabel = ({ text, className }) => <div className={cls('text-sm font-semibold text-gray-500', className)}>{text}</div>;

export default ViewLabel;
